// The Abiri of Ile-Ife UTME JAMB Support 2027 — LGA/town/school/exam-centre
// reference data. Kept in its own file (separate from the page component)
// since these lists are expected to be expanded/corrected over time.

export const LGAS = ["Ife South", "Ife North", "Ife Central", "Ife East", "Others"];

export const EXAM_CENTRES = [
  "Ile-Ife - Ife Central",
  "Olode - Ife South",
  "Ipetumodu - Ife North",
  "Ile-Ife - Ife East",
];

// Real towns/communities per LGA (Osun State) — an "Others" escape hatch is
// always included since no list can be perfectly exhaustive.
export const TOWNS_BY_LGA = {
  "Ife Central": [
    "Ilare",
    "Iremo",
    "Akarabata",
    "Moore / Ojaja",
    "Oranmiyan",
    "Enuwa",
    "Lagere",
    "Others",
  ],
  "Ife East": [
    "Modakeke",
    "Yekemi",
    "Wanikin",
    "Eleja",
    "Ilode",
    "Okerewe",
    "Oke-Ogbo",
    "Others",
  ],
  "Ife North": [
    "Ipetumodu",
    "Moro",
    "Edunabon",
    "Asipa",
    "Akinlalu",
    "Yakoyo",
    "Isope",
    "Famia",
    "Oyere",
    "Others",
  ],
  "Ife South": [
    "Ifetedo",
    "Abiri",
    "Olode",
    "Oke-Owena",
    "Kere",
    "Aye-Amodo",
    "Mefoworade",
    "Osi",
    "Ikija",
    "Aare",
    "Others",
  ],
};

// Known secondary schools per LGA — same "Others" escape hatch applies.
export const SCHOOLS_BY_LGA = {
  "Ife Central": [
    "St. David Grammar School, Ile-Ife",
    "Oluorogbo High School",
    "Moremi High School, Ile-Ife",
    "Ebenezer Baptist School, Ile-Ife",
    "Oduduwa College, Ile-Ife",
    "Ife Girls High School",
    "Urban Day Grammar School, Ile-Ife",
    "Others",
  ],
  "Ife East": [
    "Osun Government High School, Modakeke",
    "Community Grammar School, Modakeke",
    "Modakeke High School",
    "Ogunsua Grammar School, Modakeke",
    "St. Peter's A/C Grammar School",
    "St. John's Grammar School, Ile-Ife",
    "Ansaru-deen Society Grammar School",
    "Others",
  ],
  "Ife North": [
    "Federal Government Girls' College, Ipetumodu",
    "Blessing Model College, Ipetumodu",
    "C&S Grammar School, Ipetumodu",
    "Funtonlomo Comprehensive College, Ipetumodu",
    "L.A. Secondary Grammar School, Ipetumodu",
    "Anglican Secondary School, Edunabon",
    "Origbo Anglican Grammar School, Moro",
    "Standard High School, Moro",
    "Others",
  ],
  "Ife South": [
    "Ifetedo High School",
    "Baptist Grammar School, Mefoworade",
    "Eyenla Community High School",
    "L.A.G Grammar School, Ifetedo",
    "Ifesowapo Grammar School",
    "Aderemi Memorial College",
    "Ayedun Grammar School, Labata",
    "Others",
  ],
};
